import React from 'react'

const MapPointerIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width='35'
    height='35'
    viewBox='0 0 35 35'
    fill='currentcolor'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M17.5013 2.91699C11.8576 2.91699 7.29297 7.48158 7.29297 13.1253C7.29297 20.7816 17.5013 32.0837 17.5013 32.0837C17.5013 32.0837 27.7096 20.7816 27.7096 13.1253C27.7096 7.48158 23.1451 2.91699 17.5013 2.91699ZM17.5013 16.7712C15.4888 16.7712 13.8555 15.1378 13.8555 13.1253C13.8555 11.1128 15.4888 9.47949 17.5013 9.47949C19.5138 9.47949 21.1471 11.1128 21.1471 13.1253C21.1471 15.1378 19.5138 16.7712 17.5013 16.7712Z'
      fill='currentcolor'
    />
  </svg>
)

export default MapPointerIcon
